import React from 'react';
import { Table, Tag, Progress, Space, Button, Dropdown, Menu } from 'antd';
import { SettingOutlined, BugOutlined, PlayCircleOutlined, PauseCircleOutlined, DeleteOutlined, MoreOutlined } from '@ant-design/icons';

const SensorTable = ({ sensors, onAction }) => {
  console.log('Sensors:', sensors);
  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id' },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Type', dataIndex: 'type', key: 'type' },
    { 
      title: 'Status', 
      dataIndex: 'status', 
      key: 'status',
      render: (status) => (
        <Tag color={status === 'Active' ? 'green' : status === 'Inactive' ? 'red' : 'orange'}>
          {status}
        </Tag>
      ),
    },
    { title: 'Last Ping', dataIndex: 'lastPing', key: 'lastPing' },
    { 
      title: 'Battery', 
      dataIndex: 'batteryLevel', 
      key: 'batteryLevel',
      render: (batteryLevel) => (
        <Progress percent={batteryLevel} size="small" />
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Dropdown overlay={
          <Menu>
            <Menu.Item key="configure" icon={<SettingOutlined />} onClick={() => onAction('configure', record)}>
              Configure
            </Menu.Item>
            <Menu.Item key="diagnose" icon={<BugOutlined />} onClick={() => onAction('diagnose', record)}>
              Diagnose
            </Menu.Item>
            <Menu.Item 
              key="activateDeactivate" 
              icon={record.status === 'Active' ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
              onClick={() => onAction(record.status === 'Active' ? 'deactivate' : 'activate', record)}
            >
              {record.status === 'Active' ? 'Deactivate' : 'Activate'}
            </Menu.Item>
            <Menu.Item key="delete" icon={<DeleteOutlined />} onClick={() => onAction('delete', record)}>
              Delete
            </Menu.Item>
          </Menu>
        } trigger={['click']}>
          <Button icon={<MoreOutlined />} />
        </Dropdown>
      ),
    },
  ];

  return <Table columns={columns} dataSource={sensors} rowKey="id" />;
};

export default SensorTable;